import { GET_DETAILPRODUCT, GET_LOADER } from "../const";
import { DetailProductType } from "../type/detailProduct.type";

export interface DetailProductReducer {
    detailProduct: DetailProductType;
    loader: boolean;
}
const initialState: DetailProductReducer = {
    detailProduct: {} as DetailProductType,
    loader: true,
};
const detailProductReducer = (state = initialState, { type, payload }: any) => {
    switch (type) {
        case GET_DETAILPRODUCT:
            return {
                ...state,
                detailProduct: payload,
                loader: false,
            };
        case GET_LOADER:
            return {
                ...state,
                loader: payload,
            };
        default:
            return state;
    }
};
export default detailProductReducer;
